import React from 'react';
import DS_FaqList from '../../../sections/DS_Faq/components/DS_FaqList';

/**
 * Render inline link in rich text
 *
 *
 * @returns {React.ReactElement}
 */
function EmbbedEntryFAQ(fields, isRichText) {
  const { headlineVariant, faqs } = fields;
  return (
    <div>
      {' '}
      <DS_FaqList faqs={faqs} headlineVariant={headlineVariant} isRichText={isRichText}></DS_FaqList>
    </div>
  );
}

export default EmbbedEntryFAQ;
